import { Environment, getEnvironment } from '@backoffice-frontend/environment'

const HERE_ROAD_NETWORK_MAP_API_KEY =
  'i3Tw8hhHXh_-B1a4bk1dKfCUmzUQpqL4Oe6QRtiiIAU'
const HERE_STOP_NETWORK_MAP_API_KEY =
  '3KJ2kIfH3XhWu7IcIVwalPqUkvKVp_Zp27JALzfFUNU'
const HERE_FLEET_MAP_API_KEY = 'T9uH9PIu9-PWjTqkKXawiDYCim4XgfxAxaYDitXzw2Q'
const HERE_VIRTUAL_TESTING_BASEMAP_API_KEY =
  'vQORiKJx8BUnWfUB662XOVCDonRXMIj-DDNQmXPBypo'

const getHereApiKey = (key: string): string => {
  if (getEnvironment() === Environment.test) return 'testKey'
  return key
}

export const getHereApiKeyForRoadNetworkMap = () =>
  getHereApiKey(HERE_ROAD_NETWORK_MAP_API_KEY)

export const getHereApiKeyForStopNetworkMap = () =>
  getHereApiKey(HERE_STOP_NETWORK_MAP_API_KEY)

export const getHereApiKeyForFleetMap = () =>
  getHereApiKey(HERE_FLEET_MAP_API_KEY)

export const getHereApiKeyForVirtualTestingBasemap = () =>
  getHereApiKey(HERE_VIRTUAL_TESTING_BASEMAP_API_KEY)
